(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9868,9921],{

/***/ 82199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseOrderBy = __webpack_require__(16048),
    isArray = __webpack_require__(54197);

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

module.exports = orderBy;


/***/ }),

/***/ 49868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23097);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60463);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33616);
/* harmony import */ var _layouts_home_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27705);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1676);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(90946);
/* harmony import */ var _helpers_application__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16828);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(32019);
/* harmony import */ var _shared_loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34151);
/* harmony import */ var _shared_image_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58082);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46572);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _home_horizontal_calendar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7733);
/* harmony import */ var _events_grouped_events_list__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(18864);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(64075);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _src_queries__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36712);
/* harmony import */ var _shared_centered__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(91652);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(78962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_flatten__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(49154);
/* harmony import */ var lodash_flatten__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_flatten__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(18156);
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_groupBy__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(82199);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _shared_dummy_margin__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(19921);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





















var EventsList = function(param1) {
    var token = param1.token, group = param1.group, onlyList = param1.onlyList;
    var ref15, ref1, ref2, ref3;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_14__.useRouter)();
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("common").t;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(dayjs__WEBPACK_IMPORTED_MODULE_11___default()()), selectedDate = ref4[0], setSelectedDate = ref4[1];
    var ref5 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_19__/* .useInView */ .YD)(), ref6 = ref5.ref, inView = ref5.inView;
    var ref7 = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_4__.useSession)(), session = ref7.data;
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), events = ref8[0], setEvents = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), challenges = ref9[0], setChallenges = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), q = ref10[0], setQ = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), qChallenges = ref11[0], setQChallenges = ref11[1];
    var ref12;
    var ref13 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_20__/* .useInfiniteQuery */ .N)([
        "users_events",
        session === null || session === void 0 ? void 0 : (ref15 = session.user) === null || ref15 === void 0 ? void 0 : ref15.id,
        q
    ], function(param) {
        var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
        return (0,_src_queries__WEBPACK_IMPORTED_MODULE_12__/* .getEvents */ .vw)({
            pageParam: pageParam,
            q: q
        });
    }, {
        getNextPageParam: function(lastPage) {
            var ref;
            return (ref12 = (ref = lastPage.pagination) === null || ref === void 0 ? void 0 : ref.next_page) !== null && ref12 !== void 0 ? ref12 : undefined;
        },
        enabled: (session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.id) !== undefined && selectedDate !== null && q !== null
    }), data = ref13.data, isFetching = ref13.isFetching, fetchNextPage = ref13.fetchNextPage;
    var ref14 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_20__/* .useInfiniteQuery */ .N)([
        "users_challenges",
        session === null || session === void 0 ? void 0 : (ref2 = session.user) === null || ref2 === void 0 ? void 0 : ref2.id,
        qChallenges
    ], function(param) {
        var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
        return (0,_src_queries__WEBPACK_IMPORTED_MODULE_12__/* .getChallenges */ .yB)({
            pageParam: pageParam,
            q: {
                group_token_or_groups_token_eq: token,
                ends_at_gteq: selectedDate.format(_helpers_application__WEBPACK_IMPORTED_MODULE_5__/* .ISO_DATE_FORMAT */ .c2)
            },
            per_page: 25
        });
    }), challenges_data = ref14.data;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (inView && !isFetching) {
            fetchNextPage();
        }
    }, [
        inView,
        fetchNextPage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!selectedDate) return;
        var formattedDate = selectedDate.format(_helpers_application__WEBPACK_IMPORTED_MODULE_5__/* .ISO_DATE_FORMAT */ .c2);
        setQ(_objectSpread({}, q, {
            groups_token_or_admin_group_token_eq: token,
            starts_at_gteq: formattedDate,
            per_page: 5
        }));
    }, [
        selectedDate
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!data) return;
        var allEvents = data.pages.map(function(page) {
            return page.data;
        });
        var groupedEvents = Object.entries(lodash_groupBy__WEBPACK_IMPORTED_MODULE_16___default()(lodash_flatten__WEBPACK_IMPORTED_MODULE_15___default()(allEvents), "start_date"));
        setEvents(groupedEvents);
    }, [
        data
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        if (!challenges_data) return;
        var allChallenges = challenges_data === null || challenges_data === void 0 ? void 0 : (ref = challenges_data.pages) === null || ref === void 0 ? void 0 : ref.map(function(page) {
            return page.data;
        });
        setChallenges(Object.entries(lodash_groupBy__WEBPACK_IMPORTED_MODULE_16___default()(lodash_flatten__WEBPACK_IMPORTED_MODULE_15___default()(allChallenges), "starts_at")));
    }, [
        challenges_data
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: onlyList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_events_grouped_events_list__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        challenges: challenges,
                        events: events,
                        t: t
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-center",
                        ref: ref6,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_loader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            visible: isFetching
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_dummy_margin__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {})
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts_home_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: t("groups.events.title"),
            navbarLeft: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: "nav-item p-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: "nav-link navbar-brand float-start ms-0 ps-0",
                    onClick: function() {
                        return router.replace("/groups/".concat(token));
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_icon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        name: "back"
                    })
                })
            }),
            navbarRight: (group === null || group === void 0 ? void 0 : group.allow_challenges) && (group === null || group === void 0 ? void 0 : (ref3 = group.current_users_group) === null || ref3 === void 0 ? void 0 : ref3.is_admin) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "nav-item p-0 dropdown dropdown-menu-end dropdown-menu-lg-start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "nav-link navbar-brand float-end me-0 pe-0",
                            "data-bs-toggle": "dropdown",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_icon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                name: "plus-circle"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                            className: "dropdown-menu position-absolute",
                            style: {
                                overflow: "overlay",
                                right: 0,
                                left: "auto",
                                zIndex: 1032
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                        href: (0,_helpers_application__WEBPACK_IMPORTED_MODULE_5__/* .groupNewResourceLink */ .gc)(token, "events"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: "dropdown-item",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_icon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    name: "hands",
                                                    width: 20
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "ms-1",
                                                    children: t("events.one")
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                        href: (0,_helpers_application__WEBPACK_IMPORTED_MODULE_5__/* .groupNewResourceLink */ .gc)(token, "challenges"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: "dropdown-item",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_icon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    name: "challenges",
                                                    width: 18
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "ms-1",
                                                    children: t("challenges.one")
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: "nav-item p-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                    href: (0,_helpers_application__WEBPACK_IMPORTED_MODULE_5__/* .groupNewResourceLink */ .gc)(token, "events"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "nav-link navbar-brand float-end me-0 pe-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_icon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            name: "plus-circle"
                        })
                    })
                })
            }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_home_horizontal_calendar__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    onDateChange: function(day) {
                        return setSelectedDate(day);
                    },
                    renderDaysBefore: 30,
                    renderDaysAfter: 180,
                    startDate: selectedDate
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "pt-80",
                    children: [
                        events.length === 0 && challenges.length === 0 && !isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_centered__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_icon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        name: "calendar-big",
                                        alt: "calendar",
                                        width: 60,
                                        height: 65
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-gray1 mt-12",
                                        children: t("home.nothing")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                            href: (0,_helpers_application__WEBPACK_IMPORTED_MODULE_5__/* .groupNewResourceLink */ .gc)(token, "events"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                className: "text-center d-flex justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_icon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                        name: "plus-circle-blue",
                                                        width: 20,
                                                        height: 20
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "ms-1",
                                                        children: t("common:create")
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_events_grouped_events_list__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            events: events,
                            challenges: challenges,
                            t: t
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-center",
                    ref: ref6,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_loader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        visible: isFetching
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EventsList);


/***/ }),

/***/ 7733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23097);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64075);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33616);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1676);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_3__);




var COMPARE_FORMAT = "YYYY-MM-DD";
var locales = {
    cs: __webpack_require__.e(/* import() */ 4536).then(__webpack_require__.t.bind(__webpack_require__, 64536, 23)),
    en: __webpack_require__.e(/* import() */ 8712).then(__webpack_require__.t.bind(__webpack_require__, 88712, 23)),
    sk: __webpack_require__.e(/* import() */ 8097).then(__webpack_require__.t.bind(__webpack_require__, 18097, 23))
};
var HorizontalCalendar = function(props) {
    var ref8 = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_3__.useSession)(), session = ref8.data;
    var currentDateRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var scrollableDivRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(props.startDate), selectedDate = ref1[0], setSelectedDate = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(props.renderDaysAfter || 90), renderDaysAfter = ref2[0], setRenderDaysAfter = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(props.renderDaysBefore || 90), renderDaysBefore = ref3[0], setRenderDaysBefore = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(props.startDate.subtract(renderDaysBefore, "days")), firstDate = ref4[0], setFirstDate = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(props.startDate.add(renderDaysAfter + 1, "days")), lastDate = ref5[0], setLastDate = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), arrayDates = ref6[0], setArrayDates = ref6[1];
    var executeScroll = function() {
        var date = document.getElementById(selectedDate.format(COMPARE_FORMAT));
        if (!date) return;
        var div = document.getElementById("scroll");
        var position = date.getBoundingClientRect();
        div.scrollTo(position.left - window.innerWidth / 2 + 30, 0); // get element X position and scroll to window width / 2
    };
    var handleDateClick = function(date) {
        if (date.format(COMPARE_FORMAT) !== selectedDate.format(COMPARE_FORMAT)) {
            setSelectedDate(date);
            props.onDateChange(date);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var result = [];
        var date = firstDate;
        while(dayjs__WEBPACK_IMPORTED_MODULE_1___default()(date).isBefore(lastDate)){
            result.push(date);
            date = date.add(1, "day");
        }
        setArrayDates(result);
    }, [
        firstDate,
        lastDate
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (arrayDates) {
            executeScroll();
        }
    }, [
        arrayDates
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var scrollDiv = scrollableDivRef.current;
        if (scrollDiv) {
            scrollDiv.addEventListener("wheel", function(evt) {
                evt.preventDefault();
                scrollDiv.scrollLeft += evt.deltaY;
            });
        }
    }, []);
    var isWeekendDay = function(date) {
        return date.day() == 0 || date.day() == 6;
    }; // Saturday or Sunday
    var isStartOfMonth = function(date) {
        return date.startOf("month").format(COMPARE_FORMAT) == date.format(COMPARE_FORMAT);
    };
    var getBtnTextColorByDay = function(date) {
        if (date.format(COMPARE_FORMAT) === dayjs__WEBPACK_IMPORTED_MODULE_1___default()().format(COMPARE_FORMAT)) {
            return "text-accent1";
        } else if (date.isAfter(dayjs__WEBPACK_IMPORTED_MODULE_1___default()())) {
            return "text-dark1";
        }
        return "text-gray2";
    };
    var getLabelTextColorByDay = function(date) {
        if (date.format(COMPARE_FORMAT) === dayjs__WEBPACK_IMPORTED_MODULE_1___default()().format(COMPARE_FORMAT)) {
            return "text-accent1";
        } else if (isWeekendDay(date) && date.isAfter(dayjs__WEBPACK_IMPORTED_MODULE_1___default()())) {
            return "text-dark1";
        } else if (isWeekendDay(date) && date.isBefore(dayjs__WEBPACK_IMPORTED_MODULE_1___default()())) {
            return "text-gray1";
        }
        return "text-gray2";
    };
    var getBackgroundByDay = function(date) {
        var dateFormatted = date.format(COMPARE_FORMAT);
        if ((selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.format(COMPARE_FORMAT)) == dateFormatted) {
            return "btn-primary btn-day-active";
        } else if (dateFormatted == dayjs__WEBPACK_IMPORTED_MODULE_1___default()().format(COMPARE_FORMAT)) {
            return "btn-secondary text-black";
        }
        return "";
    };
    var getBorderColorByDay = function(date) {
        if (date.isBefore(dayjs__WEBPACK_IMPORTED_MODULE_1___default()().subtract(1, "day"))) {
            return "border-2";
        } else {
            return "border-2 border-secondary-color";
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "calendar-horizontal fixed-top overflow-scroll pb-12 border-bottom mb-2 container hide-scrollbars",
            style: {
                zIndex: 1000
            },
            id: "scroll",
            ref: scrollableDivRef,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "btn-group",
                children: arrayDates.map(function(date) {
                    var ref, ref7;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        ref: date.format(COMPARE_FORMAT) == ((ref = props.selectedDate) === null || ref === void 0 ? void 0 : ref.format(COMPARE_FORMAT)) ? currentDateRef : null,
                        id: date.format(COMPARE_FORMAT),
                        className: "text-center small me-1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                className: "text-uppercase label-4 d-block mb-2 ".concat(getLabelTextColorByDay(date)),
                                children: date.locale((session === null || session === void 0 ? void 0 : (ref7 = session.user) === null || ref7 === void 0 ? void 0 : ref7.locale) || "en").format("ddd")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                onClick: function() {
                                    return handleDateClick(date);
                                },
                                className: "rounded-circle border btn btn-sm btn-day ".concat(getBorderColorByDay(date), " ").concat(getBackgroundByDay(date), " ").concat(getBtnTextColorByDay(date)),
                                children: date.format("D")
                            })
                        ]
                    }, date);
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HorizontalCalendar);


/***/ }),

/***/ 19921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23097);

var DummyMargin = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mt-".concat(props.size),
        children: "\xa0"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DummyMargin);
DummyMargin.defaultProps = {
    size: 5
};


/***/ })

}]);